<template>
    <v-app>
        <template v-if="isLoggedIn">
            <!-- <core-toolbar /> -->
            <core-drawer />
            <core-view />
        </template>

        <template v-else>
            <router-view />
        </template>
    </v-app>
</template>

<script>
export default {
    computed: {
        isLoggedIn: function() {
            return this.$store.state.isLoggedIn && this.$route.path != "/login"
        }
    }
}
</script>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
    vertical-align: unset;
}
</style>
